import React from 'react';
import { Target, MapPin, Trees, Handshake, ShieldCheck, Wallet, BriefcaseBusiness, GraduationCap, Users, Building2, Landmark, Sprout, BookOpen, Globe, ClipboardList, Image, CalendarDays, BadgeCheck } from 'lucide-react';
const icons = {
  objective:Target, area:MapPin, activities:Trees, participation:Handshake, authorization_notes:ShieldCheck, beneficiary:Wallet,
  discipline:GraduationCap, expertise:BadgeCheck, service_area:MapPin, services:BriefcaseBusiness, portfolio:Image,
  mission:Target, focus:Trees, territories:MapPin, responsible_office:Building2, managed_spaces:Trees, interventions:ClipboardList,
  area_type:MapPin, managing_body:Building2, habitats:Trees, conservation:ShieldCheck, structure_type:Landmark,
  collections:Sprout, research:BookOpen, education:GraduationCap, place_type:MapPin, initiative:Target,
  characteristics:Trees, plant_groups:Sprout, material:Sprout, species:Trees, breeds:ClipboardList, purpose:Target, husbandry:Trees,
  organization_scope:Globe, reference_organization:Users, representation_role:Users, legal_identity:Landmark, management_title:ShieldCheck,
  dates:CalendarDays, partners:Handshake,
};
export default function DetailIcon({ field, size = 19 }) {
  const Icon = icons[field] || ClipboardList;
  return <Icon size={size} aria-hidden="true" className="text-[#557448] shrink-0" />;
}
